import {useMutation} from '@tanstack/react-query';
import {config} from '../config';
import {useBankIDClient} from './useBankIDClient';

export interface BankIDCompleteRequest {
  token: string | undefined | null;
  authToken: string | undefined | null;
  bft?: string | undefined | null;
  host?: string;
  refreshAuthToken?: () => Promise<string | undefined>;
}

export interface BankIDCompleteResponse {
  redirectUrl: string;
}

export const useBankIDComplete = ({
  token,
  authToken,
  bft,
  host,
  refreshAuthToken,
}: BankIDCompleteRequest) => {
  const client = useBankIDClient(authToken ?? undefined, refreshAuthToken);
  const bankIdHost = host ?? config.bankIdHost;

  const complete = useMutation({
    mutationKey: ['bankid', 'complete', token ?? 'none'] as const,
    mutationFn: async () => {
      if (!token) throw new Error('Token required for BankID complete');
      const url = `${bankIdHost}/direct/authentication/${token}/complete`;
      const response = await client.fetchJSONBody<BankIDCompleteResponse>(
        'POST',
        url,
        {bft},
      );
      return response.redirectUrl;
    },
  });

  return {complete};
};
